import React,{Component,Fragment} from 'react';
import {BeatLoader} from 'react-spinners';
import PropTypes from "prop-types";
import Toggle from 'react-toggle';
import {get} from "../../../../server/actions";
import YearMonthForm from './yearMealForm';
let schoolId=0;
class YearMeal extends Component{
    constructor(props){
        super(props)
        this.state={
            loading:false,
            isLunch:true,
            isEdit:false,
            fireRedirect:false,
            schoolYears:[],
            finalGradesArray:[]
        }
        this.getMealCreatedGradsByMonth=this.getMealCreatedGradsByMonth.bind(this)
        this.mealGradeSelectionChange=this.mealGradeSelectionChange.bind(this);
    }
    componentWillMount=()=>{
        schoolId=sessionStorage.getItem('SchoolId');
        this.getSchoolYears();        
    }
    componentDidMount=()=>{
        this.getMealCreatedGradsByMonth();

    }
    getSchoolYears=()=>{
        this.setState({loading:true})
        get('/schoolYears/search/findByMealSchoolSchoolId?mealSchoolId=' + schoolId + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
           let _schoolYears= data._embedded.schoolYears.map(item=>{
                return {
                    schoolYearLabel:item.name, 
                    schoolYearValue:item.schoolYear
                }
            });
            this.setState({schoolYears:_schoolYears,loading:false});
        })
        .catch(
            (error) => {
                this.setState({loading:false})
                console.log('Get orderlist response', error)
            }
        );
    }
    getMealCreatedGradsByMonth=()=>{
        let finalArray= this.props.schoolGrades.map(item=>{
            let obj={name:item,checked:false,enabled:true};            
            return obj;
        });
        this.setState({finalGradesArray:finalArray});
    }
    mealGradeSelectionChange=(value,selected)=>{
        let checkboxArray=this.state.finalGradesArray;
        let itm,index;
        checkboxArray.forEach((item,i)=>{
            if(value=='select_all'){
                if(item.enabled==true){
                    item.checked=selected;
                    itm=item;
                    index=i
                    return true;
                }  
            }
            else{
            if(item.name==value){
                item.checked=selected;
                itm=item;
                index=i
                return true;
            }
        }
        });

        checkboxArray[index]=itm;
        this.setState({finalGradesArray:checkboxArray});
    }
    render(){
        return(<Fragment>
            <div className="container">
           <section className="full-width clearfix">
           <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
               <BeatLoader
                   size={20}
                   color={'#ea7066'}
                   loading={this.state.loading}
               />
           </div>
           <div className="sectionTitle">
                <h2 >                       
                    <span>{this.state.fireRedirect && 'Review'} Menu For:{sessionStorage.getItem('schoolYear')}</span>
                        <div style={{display:'inline-block',marginLeft: '50px'}}>
                            <label style={{display:'block',width:'100%'}}>
                                <span className='custom-label' style={{paddingRight:'10px',color:(this.state.isLunch)?'#b5d56a':'#a597e7'}}>Lunch</span>
                                <Toggle
                                    checked={(!this.state.isLunch) ? false : this.state.isLunch}
                                    disabled={this.state.isEdit}
                                    icons={{
                                        checked: <i className='fa fa-check' style={{fontSize: '13px'}} />,
                                        unchecked: <i className='fa fa-check' style={{fontSize: '13px'}} />,
                                        }} onChange={(e) => {this.setState({isLunch:e.target.checked})}} />
                                <span className='custom-label' style={{paddingLeft:'10px',color:(!this.state.isLunch)?'#b5d56a':'#a597e7'}}>Breakfast</span>
                            </label>
                        </div>            
                    </h2>
           </div>
           <div className="row">
               <div className="col-md-12">
                    <YearMonthForm 
                    schoolYears={this.state.schoolYears||[]} 
                    schoolGrades={this.state.finalGradesArray||[]}
                    onChangeGradeSelection={this.mealGradeSelectionChange} />
               </div>
           </div>
           </section>
           </div>
        </Fragment>)
    }

}
YearMeal.contextTypes = {
    router: PropTypes.object.isRequired
};
export default YearMeal;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/yearMeal/yearMeal.jsx